var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Icon from '../../../Icon';
const IconRefund = (_a) => {
    var { size, fill } = _a, commonProps = __rest(_a, ["size", "fill"]);
    const iconContent = {
        content: (React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M12.5303 5.78038C12.8228 5.48713 12.8228 5.01238 12.5303 4.71988L12.3165 4.50613C16.7258 4.67263 20.25 8.30038 20.25 12.7501C20.25 17.3064 16.5563 21.0001 12 21.0001C7.44375 21.0001 3.75 17.3064 3.75 12.7501C3.75 9.94963 5.03775 7.37338 7.161 5.88388C7.5 5.64613 7.58175 5.17813 7.344 4.83913C7.10625 4.50013 6.63825 4.41838 6.29925 4.65613C3.768 6.43213 2.24925 9.46963 2.24925 12.7509C2.24925 18.1351 6.615 22.5009 11.9993 22.5009C17.3835 22.5009 21.7493 18.1351 21.7493 12.7509C21.7493 7.46863 17.5478 3.16738 12.3053 3.00538L12.5295 2.78113C12.822 2.48788 12.822 2.01313 12.5295 1.72063C12.237 1.42813 11.7615 1.42738 11.469 1.72063L9.969 3.22063C9.6765 3.51388 9.6765 3.98863 9.969 4.28113L11.469 5.78113C11.7615 6.07438 12.237 6.07438 12.5295 5.78113L12.5303 5.78038Z", fill: "black" }))),
        alt: 'Refund',
    };
    return React.createElement(Icon, Object.assign({}, commonProps, { source: iconContent, size: size, fill: fill }));
};
export default IconRefund;
//# sourceMappingURL=index.js.map